import { useState } from 'react';
import { ProductClass } from '../../../../types/catalog';

interface ClassAccordionProps {
    classes: ProductClass[];
    classId: string | null;
    setClassId: (id: string | null) => void;
}

function ClassAccordion({ classes, classId, setClassId }: ClassAccordionProps) {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <div className={'filter-param' + (isOpen ? ' filter-param--opened' : '')}>
            <div className="filter-param__head" onClick={() => setIsOpen(!isOpen)}>
                <div className="filter-param__title">
                    Выберите вид товара <br /> для перехода <br /> к подбору по параметрам
                </div>
            </div>
            <div className="filter-param__body">
                <div className="filter-param__items">
                    {classes.map(({ name, id }, idx) => (
                        <div key={idx} className="filter-param__item">
                            <label className="ui-checkbox">
                                <input
                                    onChange={() => setClassId(id === classId ? null : id)}
                                    className="ui-checkbox__control"
                                    checked={id === classId}
                                    type="radio"
                                />
                                <span className="ui-checkbox__icon ui-radio__icon" />
                                <span className="ui-checkbox__text">{name}</span>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ClassAccordion;
